/*
 * Bootstrap file - Contains common initialization logic for entire application
 */

window.Popper = require('popper.js').default;
window.axios = require('axios');
import tooltip from '@adaptivemedia/vue-tooltip';
import { EventBus } from './events/EventBus';
require('./helpers');

window.EventBus = EventBus;
Vue.directive('tooltip', tooltip);

// Axios setup
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Set default map location to Stockholm
window.defaultMapCenter = {
    lat: 59.3275,
    lng: 18.055,
};

// Make document locale easier to access
window.locale = document.documentElement.lang;
